import React from 'react';
import { Link } from 'react-router-dom';

// The two screening tiles from the MoSAIC mockups, shared by the MoSAIC splash
// and the foot of MoSAIC PSYOPS Explained. Colours are sampled from the
// mockup - the pink and navy are only used here, so they stay inline rather
// than entering the Tailwind theme.
const SCREENINGS = [
  {
    to: '/dashboard/catfishing-romance',
    title: 'Catfishing / Romance.',
    background: '#F18BD1',
    text: 'text-black',
  },
  {
    to: '/dashboard/pig-butchering-crypto',
    title: 'Pig Butchering / Crypto.',
    background: '#17263C',
    text: 'text-white',
  },
];

const ScreeningTiles = () => (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
    {SCREENINGS.map((s) => (
      <Link
        key={s.to}
        to={s.to}
        style={{ backgroundColor: s.background }}
        className={`block px-7 py-6 min-h-[170px] transition-opacity hover:opacity-90 ${s.text}`}
      >
        <span className="flex items-start justify-between gap-4">
          <span className="text-2xl xl:text-3xl leading-tight">{s.title}</span>
          <span aria-hidden="true" className="text-2xl xl:text-3xl leading-none">
            &rarr;
          </span>
        </span>
        <span className="block text-2xl xl:text-3xl leading-tight mt-2">Screening</span>
      </Link>
    ))}
  </div>
);

export default ScreeningTiles;
